export const GRID_CASE_ITEM_HEIGHT = 550;
export const FILTERED_TITLE_ITEM_HEIGHT = 440;
export const CASES_AMOUNT = 4;
export const CASES_INCREMENT = 4;
